import { gql } from '@apollo/client';

const CREATE_CONVERSATION = gql`
  mutation CreateDirectMessageConversation($userIds: [Int!]) {
    directMessageContext {
      createConversation(userIds: $userIds) {
        directMessageConversationId
        hasCurrentUserApproved
        isApproved
        members {
          name
          userId
          username
          avatarUrl
          hasApproved
        }
      }
    }
  }
`;

export default CREATE_CONVERSATION;
